import styled from 'styled-components';

interface TextareaProps {
  hasError?: boolean;
  minHeight?: string;
  resize?: 'none' | 'vertical' | 'horizontal' | 'both';
}

export const Textarea = styled.textarea<TextareaProps>`
  padding: 12px;
  border: 1px solid ${props => props.hasError ? '#dc2626' : '#d1d5db'};
  border-radius: 8px;
  font-size: 0.95rem;
  min-height: ${props => props.minHeight || '100px'};
  resize: ${props => props.resize || 'vertical'};
  font-family: inherit;
  transition: border-color 0.2s ease;
  width: 100%;
  background: white;

  &:focus {
    outline: none;
    border-color: ${props => props.hasError ? '#dc2626' : '#667eea'};
    box-shadow: 0 0 0 3px ${props => props.hasError ? 'rgba(220, 38, 38, 0.1)' : 'rgba(102, 126, 234, 0.1)'};
  }
  
  &:disabled {
    background: #f3f4f6;
    cursor: not-allowed;
    opacity: 0.6;
  }
  
  &::placeholder {
    color: #9ca3af;
  }
`;